module.exports = __webpack_public_path__ + "static/media/pdf-icon.e5567204.svg";